import React from 'react';

export default function Hakkimizda() {
  return (
    <section className="py-5">
      <div className="container">
        <h1 className="text-center mb-5" style={{marginTop: '50px'}}>Hakkımızda</h1>
        <div className="row">
          <div className="col-lg-6 mb-4">
            <h2 className="h3 mb-3">Ankara Tandoğan Rotaract Kulübü</h2>
            <p style={{ textAlign: 'justify' }}>
              Ankara Tandoğan Rotaract Kulübü, Rotary’nin kuruluşunun 100. yılında, 24 Şubat 2004 tarihinde charterını alarak faaliyetlerine başlamıştır. Bu yönüyle kulübümüz, ikinci Rotary yüzyılının ilk kulübü olma özelliğini taşımaktadır. Kuruluş hikayesinden aldığı bu güçlü mirasla kulübümüz, yıllar boyunca birçok toplantı, proje ve etkinliğe ev sahipliği yaparak hem üyeleri hem de içinde bulunduğu toplum için değer üretmeye devam etmiştir.
            </p>
            <p style={{ textAlign: 'justify' }}>
              Bugüne kadar gerçekleştirdiğimiz projelerin ve etkinliklerin merkezinde her zaman “Hizmet Yoluyla Dostluk” anlayışı yer almıştır. Bizim için Rotaract, yalnızca bir kulüp faaliyeti değil; fikirlerin buluştuğu, enerjinin paylaşıldığı ve birlikte gerçek etki yaratılan bir yolculuktur.
            </p>
            <p style={{ textAlign: 'justify' }}>
              Projelerimizi planlarken toplumun ihtiyaçlarını merkeze alır, her çalışmada çıtayı biraz daha yukarı taşımayı hedefleriz. Bu anlayışla kimi zaman kütüphane yaparken duvar boyadık, kimi zaman farklı ülkelerden gelen genç arkadaşlarımıza ülkemizi ve kültürümüzü tanıttık. Her projede aynı heyecan, aynı motivasyon ve aynı ekip ruhuyla hareket ettik. Bu yolculukta bize ilham veren en önemli sözlerden biri ise Mustafa Kemal Atatürk’ün “Ülkesini en çok seven, onun için en çok çalışandır.” sözüdür.
            </p>
            <p style={{ textAlign: 'justify' }}>
              Bugün Ankara Tandoğan Rotaract Kulübü olarak; enerjimiz, üretkenliğimiz ve güçlü ekip ruhumuzla yeni projeler üretmeye, dostluklar kurmaya ve topluma katkı sağlamaya ilk günkü heyecanla devam ediyoruz. Çünkü biz inanıyoruz ki; birlikte çalıştığımızda yalnızca projeler değil, kalıcı değerler de ortaya çıkar.
            </p>
          </div>
          <div className="col-lg-6 mb-4">
            <img
              src="/images/hakkimizda_foto.jpeg"
              alt="Hakkımızda"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
